<template>
    <b-card no-body class="card-browser-states">
        <b-card-header>
            <div>
                <b-card-title class="text-primary">Mes statistiques
                </b-card-title>
            </div>
        </b-card-header>

        <b-card-body class="p-1">

            <b-row  class="ml-1">
                <section style="width:100%; margin:0px;">
                    <div class="w-100 d-flex justify-content-evenly">
                        <div class="w-100 d-flex align-items-center  justify-content-start" style="font-weight: 900;">Nombre total de contrats</div>
                        <div style="margin-bottom:5px" class="w-50  d-flex align-items-center justify-content-center bd-highlight">{{ statistiqueContratsByAssureur }}</div>
                    </div>

                    <div class="w-100 d-flex justify-content-evenly" style="margin-top:10px;" >
                        <div class="w-100 d-flex align-items-center  justify-content-start">Répartition par produit</div>
                    </div>

                    <div  style="margin:0px;height:95px;" id="scrollbar2">
                        <div v-for="(produit) in contratParProduitStatistiqueByAssureur" :key="produit.id" class="w-100 d-flex justify-content-evenly"  >
                            <div class="w-100 d-flex align-items-center  justify-content-start">- {{ produit.produit_nom }}</div>
                            <div style="margin-bottom:5px" class="w-50  d-flex align-items-center justify-content-center bd-highlight">{{ produit.tarification_count }}</div>
                        </div>
                    </div>
                </section>

                <section style=" width: 100%; margin-top:10px;"  >
                    <div class="w-100 d-flex justify-content-evenly">
                        <div class="w-100 d-flex align-items-center  justify-content-start" style="font-weight: 900;">Nombre total de devis</div>
                        <div class="w-50  d-flex align-items-center justify-content-center bd-highlight">{{ statistiqueDevisByAssureur }}</div>
                    </div>

                    <div>
                        <div class="w-100 d-flex justify-content-evenly" style="margin-top:10px;"  >
                            <div class="w-100 d-flex align-items-center  justify-content-start">Répartition par produit</div>
                        </div>

                        <div  style="margin:0px;height:95px;" id="scrollbar2" >
                            <div v-for="(produit) in devisParProduitStatistiqueByAssureur" :key="produit.id" class="w-100 d-flex justify-content-evenly"  >
                                <div class="w-100 d-flex align-items-center  justify-content-start">- {{ produit.produit_nom }}</div>
                                <div style="margin-bottom:5px" class="w-50  d-flex align-items-center justify-content-center bd-highlight"> {{ produit.tarification_count }}</div>
                            </div>
                            
                            
            
                        </div>
                    </div>
                </section>

          
                <section style="width:100%; margin-top:10px;">
                    <div class="w-100 d-flex justify-content-evenly">
                        <div class="w-100 d-flex align-items-center  justify-content-start" style="font-weight: 900;">Nombre total de cabinets codés</div>
                        <div style="margin-bottom:5px" class="w-50  d-flex align-items-center justify-content-center bd-highlight">{{ nombreCodeParAssureur }}</div>
                    </div>
                </section> 
            </b-row>

        </b-card-body>
    </b-card>
</template>

<script>
import {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BImg,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    VBPopover,
    VBTooltip,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Ripple from "vue-ripple-directive";

/* eslint-disable global-require */
export default {
    components: {
        BRow,
        BCard,
        BCol,
        BCardHeader,
        BCardTitle,
        BCardText,
        BCardBody,
        BMedia,
        BMediaAside,
        BMediaBody,
        BImg,
        BDropdown,
        BDropdownItem,
        VueApexCharts,
    },
    directives: {
        "b-tooltip": VBTooltip,
        "b-popover": VBPopover,
        Ripple,
    },
    props: {
        statistiqueDevisByAssureur: Number,
        statistiqueContratsByAssureur: Number,
        nombreCodeParAssureur: Number,
        devisParProduitStatistiqueByAssureur: {
            type: Array,
            default: [],

        },
        contratParProduitStatistiqueByAssureur: {
            type: Array,
            default: [],

        }

    },


}

</script>
<style>
 #scrollbar2{
        width:100%;
        height: 50px;
        overflow-y:auto;
    }


   #scrollbar2::-webkit-scrollbar {
        width: 4px;
    }
        
    #scrollbar2::-webkit-scrollbar-track {
        border-radius: 8px;
        background-color: #e7e7e7;
        border: 1px solid #cacaca;
        box-shadow: inset 0 0 6px rgb(174, 145, 252);
    }
    
    #scrollbar2::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background-color: rgb(77, 37, 188);
    }

</style>